import { UOM_INIT_LOADING, UOM_INIT_SUCCESS, UOM_INIT_FAIL } from '@/store/types'
export const uom = {
  [UOM_INIT_LOADING](state) {
    state.uom.init = 0
    state.uom.initErr = []
    state.uom.menu = {}
  },
  [UOM_INIT_SUCCESS](state, data) {
    state.uom.init = 1
    state.uom.initErr = []
    state.uom.menu = data.menu
  },
  [UOM_INIT_FAIL](state, error) {
    state.uom.init = 2
    state.uom.initErr = error
    state.uom.menu = {}
  }
}
